import { render, staticRenderFns } from "./rootsDetail.vue?vue&type=template&id=1d4ebfdd&scoped=true&"
import script from "./rootsDetail.vue?vue&type=script&lang=js&"
export * from "./rootsDetail.vue?vue&type=script&lang=js&"
import style0 from "./rootsDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./rootsDetail.vue?vue&type=style&index=1&id=1d4ebfdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4ebfdd",
  null
  
)

export default component.exports